import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder_small",
  "use": "icon-folder_small-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-folder_small\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M7.8,9.6v6h8.4v-6Zm4.45-1.8H17.4a.6.6,0,0,1,.6.6v8.4a.6.6,0,0,1-.6.6H6.6a.6.6,0,0,1-.6-.6V7.2a.6.6,0,0,1,.6-.6h4.45Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol